import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import { useTableContext } from './internal/TableContext';
import { default as withStyles } from '../styles';
import { default as MuiTableHead } from '@material-ui/core/TableHead';
var styles = {
  root: {
    lineHeight: 1.5,
    fontWeight: 400
  }
};
/**
 * Table header
 */

var TableHead = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = props.classes,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classOverrides = {
    // Necessary style overrides are set here
    // See Material UI documentation for available CSS classes to override
    root: classes.root
  };

  var _useTableContext = useTableContext(),
      rowSelectionEnabled = _useTableContext.rowSelectionEnabled;

  var localChildren = children;

  if (rowSelectionEnabled) {
    // decorates all child TableRows, to let them know they're children of
    // a table body
    localChildren = React.Children.map(children, function (child) {
      if (child.type === TableRow) {
        return /*#__PURE__*/React.cloneElement(child, {
          parentRowGroup: 'tablehead'
        });
      } else {
        return child;
      }
    });
  }

  return /*#__PURE__*/React.createElement(MuiTableHead, _extends({}, rest, {
    classes: classOverrides,
    ref: ref
  }), localChildren);
});
TableHead.muiName = 'TableHead';
TableHead.displayName = 'TableHead';
TableHead.propTypes = {
  /**
   * The content of the table head, normally `TableRow`
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
}; // If default props are needed, they must be set here

TableHead.defaultProps = {
  component: 'thead'
};
export default withStyles(styles)(TableHead);